import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card,Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";

const modeloDatos = {
    secuenciaID: 0,
    empresaID: 0,
    cod_Secuencia: "",
    descripcion: "",
    plantilla: "",
    longitud: "",
    siguiente: 0,
    anterior: 0,
    maximo: 0,
    fechavalido: new Date,
    esncf:0

}

const SecuenciaNumerica = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [interativo, Setinterativo] = useState(false);

    let use = JSON.parse(user);

    const handleChange = (e) => {
        let value = e.target.value //e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Administracion/ListaSecuenciaNumerica/" + use.empresaID);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)



        }
    }

    useEffect(() => {
        obtenerDatos();
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        if (tabla.secuenciaID == 0) {
            response = await fetch(Api + "Administracion/GuardarSecuenciaNumerica", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            obtenerDatos()
            setVerModal(!verModal);
        } else {
            response = await fetch(Api + "Administracion/EditarSecuenciaNumerica", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {

           
                setTabla(modeloDatos);
                setVerModal(!verModal);
          
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.secuenciaID,
            sortable: true,
        },
        {
            name: 'Texto ',
            selector: row => row.descripcion,
            sortable: true,
        },


        {
            name: 'Plantilla',
            selector: row => row.plantilla,
            sortable: true,
        },    {
            name: 'Siguiente',
            selector: row => row.siguiente,
            sortable: true,
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Lista de Secuencias Numerica
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                    </a>
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nueva Secuencia</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader>
                    <a className="btn"  onClick={cerrarModal}>X</a>     Mantenimiento de Secuencia Numerica
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Descripcion </Label>
                                <Input  bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup>
                        </Col>
                    
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Plantilla</Label>
                                <Input  bsSize="sm" name="plantilla" onChange={handleChange} value={tabla.plantilla} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Longitud expresada en 0</Label>
                                <Input bsSize="sm" name="longitud" onChange={handleChange} value={tabla.longitud} />

                            </FormGroup>
                        </Col>

                        <Col sm={6}>
                            <FormGroup>
                                <Label>Siguiente</Label>
                                <Input  bsSize="sm" name="siguiente" onChange={handleChange} value={tabla.siguiente} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Anterior</Label>
                                <Input bsSize="sm" name="anterior" onChange={handleChange} value={tabla.anterior} />

                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Maximo</Label>
                                <Input type="text" bsSize="sm" name="maximo" onChange={handleChange} value={tabla.maximo} />

                            </FormGroup>
                        </Col>

                            <Col sm={6}>
                                <FormGroup>
                                    <Label>ES NCF</Label>
                                <Input bsSize="sm" type={"select"} name="esncf" onChange={handleChange} value={tabla.esncf} className="form-control">
                                    <option value={0}>No </option>
                                    <option value={1}>Si</option>

                                </Input>
                                </FormGroup>
                            </Col>
                       
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Fecha Valido</Label>
                                <Input bsSize="sm" type="date" name="fechaValido" onChange={handleChange} value={Moment(tabla.fechaValido).format('YYYY-MM-DD')}  />

                            </FormGroup>
                        </Col>
                       

                       
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div > <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button></div>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {/*<a href="\imagen\Manual de usuario Sistema Evaluación de Desempeño ETED.pdf" target="_blank" >Descargar Manual PDF</a>*/}
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Secuencia.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

        </>
    )

}
export default SecuenciaNumerica;